import { FiltersEnum } from "app/components/filters-bar/utils";
import { AccessWithoutMandatoryParamsHOC } from "app/components/React/HOCs/accessWithoutMandatoryParamsHOC";
import { withAllContextHoc } from "app/components/React/HOCs/withAllContextsHOC";
import { ProductAdsTableKeywordsContext } from "app/components/React/PlaResearch/ProductAdsResearch";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { KeywordResearchTopKeywordsHomepageContainer } from "app/pages/digital-marketing/keywordResearchTopKeywordsHomepageContainer";
import { SiteAuditHomepageWrapper } from "app/pages/digital-marketing/site-audit/SiteAuditHomePageWrapper";
import { IndustryAnalysisRoute } from "app/pages/industry-analysis/routes/IndustryAnalysisRoute";
import { KeywordsRootLayout } from "app/pages/keyword-research/keyword-analysis/common-components/KeywordsRootLayout";
import { SerpPlayersPage } from "app/pages/keyword-research/keyword-analysis/pages/serp-players/SerpPlayersPage";
import { KeywordCompetitorsPaidPage } from "app/pages/keyword-research/website-analysis/pages/search-competitors/KeywordCompetitorsPaidConfig";
import { DemandAnalysisHomePage } from "app/pages/market-research/DemandAnalysisHomePage";
import { QualificationSideBarContainer } from "app/pages/website-analysis/components/qualification-sidebar/QualificationSideBarContainer";
import { Phrases } from "app/pages/website-analysis/traffic-sources/search/tabs/Phrases";
import { SearchOverviewContainer } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewContainer";
import { filterConsistencyParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import { onRedirectKeywordAnalysis } from "app/routes/handlers/filter-consistency/pipes/keyword-analysis/onRedirectKeywordAnalysis";
import { onRedirectKeywordsSERPPages } from "app/routes/handlers/filter-consistency/pipes/keyword-analysis/onRedirectSERPPages";
import { onRedirectWebsiteAnalysis } from "app/routes/handlers/filter-consistency/pipes/website-analysis/onRedirectWebsiteAnalysis";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import type { EKeywordTabs } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import { resolvers } from "single-spa/react-app/config/resolvers/resolvers";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

const countryFilterPreferencesKey = "acquisitionChannels_countryFilter_tooltip_key";
const trafficOverviewSearchParams: Record<string, unknown> = {
    Keywords_filters: null,
    groupedKeywords_filters: null,
    groupedKeywords_orderby: null,
    Ads_filters: null,
    IncludeOrganic: null,
    IncludePaid: null,
    IncludeBranded: null,
    multiIncludeExcludeKeywords: null,
    IncludeNoneBranded: null,
    IncludeNewKeywords: null,
    IncludeTrendingKeywords: null,
    IncludeQuestions: null,
    limits: null,
    BooleanSearchTerms: null,
    search: null,
    selectedDomain: null,
    orderBy: null,
    ExcludeTerms: null,
    ExcludeUrls: null,
    IncludeUrls: null,
    IncludeTerms: null,
    family: null,
    source: null,
    IncludeKeywordGroups: null,
    selectedPhrase: null,
    volumeFromValue: null,
    volumeToValue: null,
    difficultyFromValue: null,
    difficultyToValue: null,
    cpcFromValue: null,
    cpcToValue: null,
    gapFilterSelectedTab: null,
    predefinedFiler: null,
    selectedIntersection: null,
    limitsUsingAndOperator: null,
    serp: null,
    ranking: null,
    ampFilter: null,
    CustomCategory: null,
    Category: null,
    funcFlag: null,
    intentsfilter: null,
    positionTrends: null,
    metric: null,
    ExcludeKeywordGroups: null,
};

const organicSearchGroupConfig: RouterStateConfig = {
    organicsearch_website_organic_search_overview: {
        parent: "organicsearch_website",
        url: `/organic-overview/:isWWW/:country/:duration?key&selectedSingleOverviewGraphTab&selectedNonBrandedTab&webSource?${Object.keys(
            trafficOverviewSearchParams,
        ).join(`?`)}`,
        component: AccessWithoutMandatoryParamsHOC(SearchOverviewContainer, "key"),
        secondaryBarType3: SecondarySideBarType3.Search,
        stateNameForEductionBar: "competitiveanalysis_website_organic_search_overview",
        redirectTo: onRedirectWebsiteAnalysis(),
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Organic Website Analysis",
            subSubSection: "overview",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "Search/Organic Website Analysis",
            subSubSection: "overview",
        },
        defaultQueryParams: {
            webSource: devicesTypes.DESKTOP,
            duration: "3m",
            isWWW: "*",
        },
        params: {
            isWWW: "*",
            duration: "3m",
            ...filterConsistencyParams,
        },
        icon: "sw-icon-search",
        hidePageTitle: true,
        searchParams: ["webSource"],
        pageTitle: "organic.search.overview.page.title",
        pageSubtitle: "competitors.organic.search.overview.page.title.info",
        isUSStatesSupported: true,
        reloadOnSearch: true,
        childStates: ({ webSource }: any) => {
            if (webSource === "total") {
                return "MarketingMixTotal";
            } else if (webSource === "mobileweb") {
                return "MobileWebSearch";
            } else {
                return "WebAnalysis";
            }
        },
        configIdDeps: [
            "AudienceOverview",
            "KeywordAnalysis",
            "MobileWebSearch",
            "MobileMarketingMix",
            "MarketingMixTotal",
        ],
        data: {
            trackPageViewOnSearchUpdate: false,
        },
        homeState: "organicsearch_websiteanalysis_home",
    },
    organicsearch_website_search_phrases: {
        parent: "organicsearch_website",
        url: `/phrases/:isWWW/:country/:duration?key&webSource?${Object.keys(trafficOverviewSearchParams).join(`?`)}`,
        secondaryBarType3: SecondarySideBarType3.Search,
        component: AccessWithoutMandatoryParamsHOC(Phrases, "key"),
        stateNameForEductionBar: "competitiveanalysis_website_search_phrases",
        redirectTo: onRedirectWebsiteAnalysis(),
        resolve: [resolvers.siteInfo],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Organic Website Analysis",
            subSubSection: "phrases",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "Search/Organic Website Analysis",
            subSubSection: "phrases",
        },
        defaultQueryParams: {
            webSource: devicesTypes.DESKTOP,
            duration: "3m",
            isWWW: "*",
        },
        params: {
            isWWW: "*",
            duration: "3m",
            ...filterConsistencyParams,
        },
        icon: "sw-icon-search",
        hidePageTitle: true,
        searchParams: ["webSource"],
        pageTitle: "competitors.search.phrases.page.title",
        pageSubtitle: "competitors.search.phrases.page.title.info",
        isUSStatesSupported: true,
        reloadOnSearch: true,
        data: {
            trackPageViewOnSearchUpdate: false,
        },
        childStates: ({ webSource }: any) => {
            return webSource === "mobileweb" ? "MobileWebSearch" : "WebAnalysis";
        },
        configIdDeps: ["AudienceOverview", "MobileWebSearch"],
        homeState: "organicsearch_websiteanalysis_home",
    },
    paidsearch_website_search_paid_competitors: {
        parent: "paidsearch_website",
        url:
            // eslint-disable-next-line max-len
            "/search/competitors-paid-keywords/:isWWW/:country/:duration?key&webSource&orderby?selectedSite?websiteType?paidSearchType?risingCompetitors?newCompetitors?category?search",
        reset: {
            orderby: null,
            selectedSite: null,
            websiteType: null,
            paidSearchType: null,
            risingCompetitors: null,
            newCompetitors: null,
            category: null,
            search: null,
        } as Record<string, unknown>,
        stateNameForEductionBar: "competitiveanalysis_website_search_paid_competitors",
        component: AccessWithoutMandatoryParamsHOC(KeywordCompetitorsPaidPage, "key"),
        qualificationSideBarComponent: QualificationSideBarContainer,
        redirectTo: onRedirectWebsiteAnalysis(),
        resolve: [resolvers.siteInfo],
        configId: "SearchCompetitors",
        pageId: {
            section: "Acquisition",
            subSection: "Search/Paid Website Analysis",
            subSubSection: "Competitive Analysis/keywordCompetitors",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "Search/Paid Website Analysis",
            subSubSection: "keywordCompetitors",
        },
        icon: "sw-icon-search-competitors",
        pageTitle: "digitalsuite.analysis.search.paid.competitors.title",
        pageSubtitle: "analysis.search.paid.competitors.title.tooltip",
        searchParams: ["selectedSite"],
        isVirtualSupported: false,
        isUSStatesSupported: true,
        reloadOnSearch: false,
        homeState: "search_websiteanalysis_home",
        defaultQueryParams: {
            webSource: "Desktop",
            duration: "3m",
            isWWW: "*",
        },
        params: {
            duration: "3m",
            isWWW: "*",
            country: "999",
            ...filterConsistencyParams,
        },
        data: {
            filtersConfig: {
                duration: FiltersEnum.DISABLED,
            },
        },
    },
};

const keywordResearchConfig = {
    digitalsuite_findkeywords_byindustry_root: {
        abstract: true,
        parent: "digitalsuite_acquisition",
        component: withAllContextHoc(IndustryAnalysisRoute),
        secondaryBarType3: SecondarySideBarType3.Search,
        configId: "IndustryAnalysis",
        data: {
            menuKbItems: false,
            disableRecording: true,
            filtersConfig: {
                duration: FiltersEnum.ENABLED,
                country: FiltersEnum.ENABLED,
                webSource: FiltersEnum.ENABLED,
            },
        },
        pageId: {
            section: "industryAnalysis",
        },
        trackingId: {
            section: "Acquisition Channels",
        },
    },
};

const keywordAnalysisConfig = {
    organicsearch_keywordanalysis_home: {
        parent: "digitalsuite_acquisition",
        url: "/organicsearch/keywordanalysis/home",
        secondaryBarType3: SecondarySideBarType3.Search,
        component: () => {
            return (
                <DemandAnalysisHomePage
                    pageState="organicsearch_keywordAnalysis_overview_2"
                    title="aquisitionintelligence.keywordresearch.keywordanalysis.home.title"
                />
            );
        },
        configId: "KeywordAnalysisHome",
        configIdDeps: ["KeywordAnalysis", "RankingDistribution"],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Keyword Analysis/Home",
            subSubSection: "Keyword_Analysis/HomePage",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "Search/Keyword Analysis/Home",
            subSubSection: "Keyword_Analysis/HomePage",
        },
        pageTitle: "aquisitionintelligence.keywordanalysis.homepage.title",
    },
    organicsearch_keywordanalysis_root: {
        abstract: true,
        parent: "digitalsuite_acquisition_root",
        url: "/keyword",
        component: KeywordsRootLayout,
        secondaryBarType3: SecondarySideBarType3.Search,
        configId: "KeywordAnalysis",
        data: {
            menuKbItems: false,
            disableRecording: true,
            getCustomUrlType: () => {
                return "Digital Marketing - Keywords";
            },
        },
        pageId: {
            section: "keywordAnalysis",
        },
        trackingId: {
            section: "Acquisition Channels",
        },
    },

    organicsearch_keywordAnalysis_organic_2: {
        parent: "organicsearch_keywordAnalysis_search_root",
        url: "/organic_2?webSource",
        component: AccessWithoutMandatoryParamsHOC(SerpPlayersPage, "keyword", "keyword"),
        redirectTo: redirectPipe(onRedirectKeywordsSERPPages()),
        defaultQueryParams: {
            webSource: devicesTypes.DESKTOP,
            country: "999",
            duration: "28d",
        },
        params: {
            webSource: { dynamic: false },
            ...filterConsistencyParams,
        },
        stateNameForEductionBar: "keywordAnalysis-organic",
        configId: "KeywordAnalysisV2Organic",
        configIdDeps: ["KeywordAnalysis", "KeywordAnalysisV2"],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Search 3.0",
            subSubSection: "Organic Traffic 2.0",
        },

        trackingId: (toParams: FixmeType) => {
            const selectedPageTab: keyof typeof EKeywordTabs = toParams?.selectedPageTab;
            return {
                section: "Acquisition Channels",
                subSection: "Search/Search 3.0",
                subSubSection: `${selectedPageTab} Traffic 2.0`,
                subSubSubSection: selectedPageTab,
            };
        },
        isUSStatesSupported: false,
        skipCountryCheck: true,
        pageTitle: "keywordanalysis.2.organic.page.title",
        pageSubtitle: "KeywordAnalysis.organic.title.tooltip",
        icon: "sw-icon-nav-organic",
        showCompareButton: true,
        homeState: "organicsearch_keywordanalysis_home",
        customData: {
            countryFilterPreferencesKey,
        },
    },

    paidsearch_keywordAnalysis_ads: {
        parent: "organicsearch_keywordAnalysis_search_root",
        url: "/topads?webSource&type&selectedCategory&orderBy&search",
        stateNameForEductionBar: "keywordAnalysis_ads",
        secondaryBarType3: SecondarySideBarType3.Search,
        component: () => {
            const props = {
                type: "text",
                emptyStateTitle: "keyword.analysis.ads.page.empty.title",
                emptyStateSubTitle: "keyword.analysis.ads.page.empty.subtitle",
            };
            return AccessWithoutMandatoryParamsHOC(
                withAllContextHoc(ProductAdsTableKeywordsContext),
                "keyword",
                "keyword",
            )(props);
        },
        redirectTo: onRedirectKeywordAnalysis(),
        configId: "KeywordsAds",
        pageId: {
            section: "Acquisition",
            subSection: "Search/Keyword Analysis",
            subSubSection: "Keyword_Analysis/topads",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "Search/Keyword Analysis",
            subSubSection: "Keyword_Analysis/topads",
        },
        isUSStatesSupported: true,
        params: {
            country: "999",
            duration: "3m",
            ...filterConsistencyParams,
        },
        reloadOnSearch: true,
        pageTitle: "digitalsuite.keywordAnalysis.ads.page.title",
        pageSubtitle: "KeywordAnalysis.ads.title.tooltip",
        showCompareButton: true,
        homeState: "paidsearch_keywordanalysis_home",
    },
    paidsearch_keywordAnalysis_plaResearch: {
        parent: "organicsearch_keywordAnalysis_search_root",
        url: "/topproducts?webSource&type&selectedCategory&orderBy&search",
        stateNameForEductionBar: "keywordAnalysis_plaResearch",
        secondaryBarType3: SecondarySideBarType3.Search,
        component: () => {
            const props = {
                type: "shopping",
                emptyStateTitle: "keyword.analysis.plaresearch.page.empty.title",
                emptyStateSubTitle: "keyword.analysis.plaresearch.page.empty.subtitle",
            };
            return AccessWithoutMandatoryParamsHOC(
                withAllContextHoc(ProductAdsTableKeywordsContext),
                "keyword",
                "keyword",
            )(props);
        },
        redirectTo: onRedirectKeywordAnalysis(),
        configId: "KeywordsAds",
        pageId: {
            section: "Acquisition",
            subSection: "Search/Keyword Analysis",
            subSubSection: "Keyword_Analysis/plaResearch",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "Search/Keyword Analysis",
            subSubSection: "Keyword_Analysis/plaResearch",
        },
        reloadOnSearch: true,
        isUSStatesSupported: true,
        params: {
            webSource: "Desktop",
            country: "999",
            duration: "3m",
            ...filterConsistencyParams,
        },
        pageTitle: "keywordAnalysis.plaResearch.page.title",
        pageSubtitle: "keyword.analysis.plaResearch.page.subTitle",
        orangeBadgeTitle: "sidenav.new",
        showCompareButton: true,
        homeState: "paidsearch_keywordanalysis_home",
    },
};

const siteAuditConfig = {
    digitalsuite_site_audit_home: {
        parent: "digitalsuite_acquisition",
        url: "/site-audit?unauthorized",
        abstract: false,
        component: SiteAuditHomepageWrapper,
        pageTitle: "digitalsuite.site_audit.homepage.pagetitle",
        trackingId: {
            section: "Site Audit",
            subSection: "Homepage",
            subSubSection: "none",
        },
    },
};

const findKeywordsByConfig = {
    digitalsuite_findkeywords_TopKeywords_home: {
        parent: "digitalsuite_acquisition",
        url: "/findkeywords/TopKeywords/home",
        component: KeywordResearchTopKeywordsHomepageContainer,
        secondaryBarType3: SecondarySideBarType3.Search,
        configId: "FindKeywordsHome",
        configIdDeps: ["IndustryAnalysisTopKeywords"],
        pageId: {
            section: "Acquisition",
            subSection: "Search/Keyword Opportunities",
            subSubSection: "Find_Keywords/homePage/Industry",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "Search/Keyword Opportunities",
            subSubSection: "Find_Keywords/homePage/Industry",
        },
        pageTitle: "digitalmarketing.findkeywords.homepage.title",
        skipDurationCheck: true,
        skipCountryCheck: true,
        params: {
            disableCustomIndustrySegmentsSupport: true,
        },
    },
};

export const searchConfig: RouterStateConfig = {
    ...organicSearchGroupConfig,
    ...keywordResearchConfig,
    ...findKeywordsByConfig,
    ...keywordAnalysisConfig,
    ...siteAuditConfig,
};
